// src/styles/theme.js

/* =========================
   CORES
========================= */
export const Colors = {
  

  primary: '#a8243e',
  secondary: '#17a2b8',
  success: '#28a745',
  danger: '#d32f2f',
  warning: '#ffc107',

  backgroundLight: '#f8f9fa',
  borderLight: '#ddd',
  white: '#ffffff',

  textDark: '#333',
  textLight: '#888',
  textMuted: '#666',

  /* STATUS */
  statusAtivoBg: '#e8f5e9',
  statusAtivoText: '#2e7d32',
  statusInativoText: '#a8243e',
  statusCanceladoBg: '#ffebee',
  statusCanceladoText: '#c62828',

  statusPendenteBg: '#fff3e0',
  statusPendenteText: '#ef6c00',

  statusValidacaoBg: '#e3f2fd',
  statusValidacaoText: '#1565c0',

  statusPagamentoPendenteBg: '#f3e5f5',
  statusPagamentoPendenteText: '#6a1b9a'

};

/* =========================
   ESTILOS INLINE
========================= */
export const Styles = {
  label: {
    fontSize: '11px',
    color: Colors.textLight,
    marginBottom: '2px',
    textTransform: 'uppercase'
  },
  value: {
    fontSize: '14px',
    fontWeight: '600',
    color: Colors.textDark,
    marginBottom: '0'
  },
  card: {
    padding: '20px',
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.borderLight}`,
    borderRadius: '8px'
  },
  buttonSuccess: {
    backgroundColor: Colors.success,
    color: Colors.white,
    padding: '10px 30px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer'
  },
  buttonCancel: {
    color: Colors.white,
    padding: '10px 30px',
    marginRight: '15px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer'
  },
  fieldset: {
    border: '1px solid #f5aa00',
    padding: '10px',
    marginTop: '15px',
    paddingBottom: '25px',
    borderRadius: '5px',
    display: 'block',
    width: '100%'
  },
  legenda_filedset: {
    width: 'auto',
    padding: '0 10px',
    fontSize: '1.2rem',
    color: Colors.primary,
    borderBottom: 'none'
  }
  

};


/* =========================
   TABELAS (RESPONSIVIDADE EM CARDS)
========================= */
export const tableStyles = `
  #table_id_wrapper {
    width: 100%;
  }

  .dt-table,
  .mdl-data-table {
    width: 100%;
    white-space: normal;
    font-family: 'RubikRegular' !important;
    color: #545454;
    border-collapse: collapse;
  }

  thead {
    background-color: ${Colors.primary};
  }

  th {
    color: #fff !important;
    font-size: 14px !important;
    text-align: left !important;
    font-weight: 500 !important;
    padding: 12px 8px;
  }

  td {
    font-size: 12px;
    border-bottom: 1px solid #ccc;
    text-align: left !important;
    padding: 12px 8px;
  }

  .table-striped tbody tr:nth-of-type(even) {
    background-color: #f2f2f2;
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: #ffffff;
  }

  /* Hover discreto na linha */
  .row_table:hover {
    background-color: rgba(168, 36, 62, 0.05) !important;
  }
    
/* 1. O Container principal (Grid) deve espalhar os itens */
  .dataTables_wrapper .mdl-grid {
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between !important; /* Manda um para cada lado */
    align-items: center !important;
    width: 100% !important;
  }

  /* 2. Garante que as colunas internas não limitem o espaço */
  .dataTables_wrapper .mdl-grid .mdl-cell {
    display: flex !important;
    flex: 1 !important;
    margin: 0 !important;
  }

  /* === TOPO DA TABELA === */

  /* Esquerda: Quantidade de Linhas (Length Menu) */
  .dataTables_length {
    justify-content: flex-start !important;
  }

  /* Direita: Filtro (Search) */
.dataTables_filter {
    display: flex !important;
    justify-content: flex-end !important; /* Empurra para a direita */
    width: 100% !important;
    text-align: right !important;
  }
/* Garante que o conteúdo dentro do filtro (label + input) se alinhe ao fim */
  .dataTables_filter label {
    display: inline-flex !important;
    justify-content: flex-end !important;
    align-items: center;
    width: 100%;
    gap: 10px;
  }

  /* === RODAPÉ DA TABELA === */

  /* Esquerda: Informações (Mostrando X de Y) */
  .dataTables_info {
    justify-content: flex-start !important;
    text-align: left !important;
    display: flex !important;
    align-items: center;
    font-size: 13px;
    
    color: #666;
  }

/* 2. Ataca o container da Paginação */
  .dataTables_paginate {
    display: flex !important;
    justify-content: flex-end !important; /* Empurra para a direita */
    width: 100% !important;
    margin-top: 15px !important;
  }
/* 3. Força as células da direita do Grid MDL a ocuparem o espaço e alinharem */
  .dataTables_wrapper .mdl-grid .mdl-cell:last-child {
    display: flex !important;
    justify-content: flex-end !important;
    text-align: right !important;
  }


  /* ===== MOBILE (Transformação em Cards) ===== */
     @media (max-width: 768px) {

  
    /* GARANTE FLUXO NORMAL DOS CARDS */
    table.dataTable {
      display: block !important;
      position: static !important;
    }

    table.dataTable tbody {
      display: block !important;
      position: static !important;
    }

    table.dataTable tr {
      display: block !important;
      position: static !important;   /* 🔴 ESSENCIAL */
      float: none !important;        /* 🔴 ESSENCIAL */
      clear: both !important;        /* 🔴 ESSENCIAL */
      height: auto !important;
      min-height: unset !important;
      margin-bottom: 18px;
    }

    table.dataTable td {
      display: flex !important;
      position: static !important;
      width: 100% !important;
      box-sizing: border-box;
    }

    /* 1. Remove completamente o cabeçalho */
    table.dataTable thead {
      display: none !important;
    }

    /* 2. Estrutura base vira bloco */
    table.dataTable,
    table.dataTable tbody,
    table.dataTable tr {
      display: block !important;
      width: 100% !important;
    }

    /* 3. Cada linha vira um CARD */
    table.dataTable tr {
      background-color: #ffffff !important;
      border-radius: 14px;
      padding: 14px 16px;
      margin-bottom: 18px;
      box-shadow: 0 6px 15px rgba(0,0,0,0.08);
      border-left: 5px solid ${Colors.primary};
    }

    /* 4. Células em layout label / valor */
    table.dataTable td {
      display: flex !important;
      justify-content: space-between;
      align-items: left;
      padding: 6px 0 !important;
      border-bottom: 1px dashed #e0e0e0;
      font-size: 14px;
    }

  table.dataTable td:last-child {
    border-bottom: none;
  }

  /* 5. Label (esquerda) */
  table.dataTable td::before {
    content: attr(data-label);
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${Colors.textMuted};
    letter-spacing: 0.03em;
  }

  /* 6. DATA = header do card */
  table.dataTable td[data-label="Data"] {
    font-weight: 700;
    font-size: 15px;
    border-bottom: 2px solid #eee;
    padding-bottom: 10px !important;
    margin-bottom: 8px;
  }

  /* 7. VALOR em destaque */
  table.dataTable td[data-label="Valor"] {
    justify-content: center;
    font-size: 20px;
    font-weight: 700;
    color: ${Colors.primary};
    padding-top: 14px !important;
  }


  /* 8. STATUS centralizado */
  table.dataTable td[data-label="Status"] {
    justify-content: center;
    padding-top: 10px !important;
  }

  /* Remove label de Valor e Status */
  table.dataTable td[data-label="Valor"]::before,
  table.dataTable td[data-label="Status"]::before {
    content: none !important;
}
/* Vendedor JUSTIFICADO (label esquerda  */
table.dataTable td[data-label="Vendedor"] {
  justify-content: space-between !important;
  text-align: right !important;
}
/* Resp. Financeiro JUSTIFICADO (label esquerda ) */
table.dataTable td[data-label="Resp. Financeiro"] {
  justify-content: space-between !important;
  text-align: justify !important;
}


  table.dataTable td span {
    font-size: 11px !important;
    padding: 6px 14px !important;
    border-radius: 20px !important;
  }

  /* 9. Neutraliza DataTables */
  table.dataTable {
    table-layout: auto !important;
  }

  table.dataTable th,
  table.dataTable td {
    width: auto !important;
    max-width: none !important;
  }

`;

/* =========================
   MENU
========================= */
export const menuStyles = `
  .menu-group-wrapper {
    width: 100%;
    background-color: transparent;
    border-bottom: 1px solid rgba(168, 36, 62, 0.05);
  }

  .menu-anchor {
    display: flex !important;
    align-items: center !important;
    padding: 12px 20px !important;
    color: ${Colors.textMuted} !important;
    width: 100% !important;
  }

  .menu-anchor:hover {
    background-color: ${Colors.primary} !important;
    color: ${Colors.white} !important;
  }

  .menu-icon {
    width: 30px !important;
    margin-right: 12px !important;
    text-align: center !important;
    font-size: 18px !important;
  }
.drawer-no-scroll ::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}
  .menu-anchor {
  display: block;
  padding: 12px 16px;
  color: #a8243e;
  text-decoration: none;
  font-size: 13px;
  border-radius: 8px;
  margin: 4px 8px;
  transition: background-color 0.25s ease, color 0.25s ease;
}

.menu-anchor:hover {
  background-color: rgba(168, 36, 62, 0.12);
  color: #a8243e;
}

.menu-anchor.active {
  background-color: rgba(168, 36, 62, 0.15);
  font-weight: 600;
  border-left: 4px solid #a8243e;
}    
`;

/* =========================
   DIALOG
========================= */
export const dialogStyles = `
  .dialog-scroll-custom ::-webkit-scrollbar {
    width: 12px !important;
    height: 12px !important;
  }

  .dialog-scroll-custom ::-webkit-scrollbar-thumb {
    background-color: #888 !important;
    border-radius: 10px !important;
  }

  .dialog-scroll-custom > div > div {
    overflow-y: scroll !important;
    -webkit-overflow-scrolling: touch !important;
  }
`;

/* =========================
   FLEX RESPONSIVO (CARDS / INFO)
========================= */
export const responsiveHelpers = `
  .flex-responsive {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 768px) {
    .flex-responsive {
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;
    }
  }
`;


/** WEBPACK FOOTER **
 ** ./src/styles/theme.js
 **/